import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';

import { AuthService } from '../services/auth/auth.service';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { catchError, map, Observable, of, switchMap } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

export const InterceptorSkipHeader = 'X-Skip-Interceptor';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private platform = inject(PLATFORM_ID);
  private authService = inject(AuthService);
  private router = inject(Router);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has(InterceptorSkipHeader)) {
      const headers = request.headers.delete(InterceptorSkipHeader);
      return next.handle(request.clone({ headers }));
    }

    const currentAccessToken = this.authService.getAccessToken();

    if (currentAccessToken && isPlatformBrowser(this.platform)) {
      if (Date.now() > new Date(currentAccessToken.expiresAt).getTime()) {
        return this.authService.refreshToken().pipe(
          map(({ accessToken }) => accessToken),
          catchError(() => {
            this.authService.removeAccessToken();
            this.router.navigate(['/app/login']);
            return of(null);
          }),
          switchMap(accessToken => {
            return next.handle(
              accessToken
                ? request.clone({
                    headers: new HttpHeaders({ 'x-token': accessToken.uid }),
                  })
                : request
            );
          })
        );
      }

      request = request.clone({
        headers: new HttpHeaders({
          'x-token': currentAccessToken.uid,
        }),
      });
    }

    return next.handle(request);
  }
}
